<template>
  <div>
    <div class="main">
      <!-- <div class="swiper-container swiper-readmore" v-swiper:mySwiper="swiperOption">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="/static/images/s1.jpg" alt="/" />
          </div>
          <div class="swiper-slide">
            <img src="/static/images/s2.jpg" alt="/" />
          </div>
          <div class="swiper-slide">
            <img src="/static/images/s3.jpg" alt="/" />
          </div>
          <div class="swiper-slide">
            <img src="/static/images/s4.jpg" alt="/" />
          </div>
          <div class="swiper-slide">
            <img src="/static/images/s5.jpg" alt="/" />
          </div>
        </div>
        <div class="swiper_bottom_shade"></div>
      </div> -->

      <!-- 一级课程 -->
      <div
        class="primarymenu container"
        :class="[{ boxout: isMobileFlg }, { 'primarymenu-add': arrowdownCss }]"
        ref="heightOut"
      >
        <ul class="clear" :class="{ boxin: isMobileFlg }" ref="heightIn">
          <li class="setCourse" v-if="checkLoginUser" @click="goRouterSetCourse('/home/setSelfMenu')">
            <img src="../../../static/images/settings.png" alt="" />
          </li>

          <li
            class="SchoolBusiness_menu_li"
            ref="heightItem_x"
            :class="currentIndex == -1 ? 'active' : ''"
            @click="firstMenuChange(-1, null)"
          >
            {{ $t("schoolBusiness.all") }}
          </li>

          <li
            class="SchoolBusiness_menu_li"
            v-for="(item, index) in menuList"
            :key="item.id"
            ref="'heightItem_'+index"
            :class="tagOne == item.id ? 'active' : ''"
            @click="firstMenuChange(index, item.id)"
          >
            {{ item.name }}
          </li>
        </ul>

        <p class="showAllCourse" v-show="arrowdownIcon" @click="cssedit">
          <!-- <img src="../../../static/images/arrow_down.png" alt=""> -->
          <i
            v-if="this.arrowdownCss"
            class="el-icon-arrow-down down_laa"
            @mouseover="mouseOverDown($event)"
            @mouseleave="mouseLeaveDown($event)"
          ></i>
          <i
            v-if="!this.arrowdownCss"
            class="el-icon-arrow-up up_laa"
            @mouseover="mouseOverUp($event)"
            @mouseleave="mouseLeaveUp($event)"
          ></i>
        </p>
      </div>

      <!-- 二级课程 -->
      <div class="secondmenu container">
        <ul v-if="changeState == true" class="clear">
          <li
            class="SchoolBusiness_menues_li"
            :class="newCurrentIndex == -1 ? 'active' : ''"
            @click="secondMenuChange(-1, null)"
          >
            {{ $t("schoolBusiness.all") }}
          </li>
          <li
            class="SchoolBusiness_menues_li"
            v-for="(item, newIndex) in secondMenuList"
            :key="item.id"
            :class="newCurrentIndex == newIndex ? 'active' : ''"
            @click="secondMenuChange(newIndex, item.id)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>

      <!-- 课程内容 -->
      <div class="change container clear">
        <div class="r" v-if="allCourseNum > limit">
          <i
            class="el-icon-refresh"
            @click="changeCourseList(tagOne, tagTwo)"
          ></i>
          <span @click="changeCourseList(tagOne, tagTwo)">{{
            $t("new.title4")
          }}</span>
        </div>
      </div>

     
      <div class="primarylists mg-top">
        <ul class="container">
          <li>
             <div
        v-if="courseList_b.length == 0"
        class="container"
        style="padding:10px; justify-content: center"
      >
       
            <span style="color: #666; font-size: 20px">{{
              $t("community.content")
            }}</span>
      
      </div>
            <div class="lessons">
              <ul class="clear">
                <li v-for="item in courseList_b" :key="item.id">
                  <div v-if="!item.isUrl">
                    <div class="img vaa">
                      <img
                        v-if="
                          item.courseCover == undefined ||
                          item.courseCover == null ||
                          item.courseCover == ''
                        "
                        src="../../../static/images/temppic.jpg"
                        alt="/"
                        @click="goto_Aicourse(item.courseId)"
                      />
                      <img
                        v-else-if="item.courseCover == '/file/'"
                        src="../../../static/images/temppic.jpg"
                        alt="/"
                        @click="goto_Aicourse(item.courseId)"
                      />
                      <img
                        v-else
                        :src="item.courseCover"
                        alt="/"
                        @click="goto_Aicourse(item.courseId)"
                      />
                    </div>
                    <div
                      class="lessontitle"
                      @click="goto_Aicourse(item.courseId)"
                    >
                      {{ item.courseName }}
                    </div>
                    <!-- [KB] - 352 -->
                    <!-- <div class="introduce" v-html="item.synopsis"></div> -->
                    <div class="like-ps">
                      <div class="islike">
                        <div>
                          <img
                            src="../../../static/images/good1.png"
                            style="
                              cursor: pointer;
                              height: 15px;
                              display: inline-block;
                            "
                          />
                          <span> {{ item.likeNum }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="img vaa">
                      <span v-html="item.courseCover"></span>
                    </div>
                    <div
                      class="lessontitle"
                      @click="goto_Aicourse(item.courseId)"
                    >
                      {{ item.courseName }}
                    </div>
                    <div class="like-ps">
                      <div class="islike">
                        <div>
                          <img
                            src="../../../static/images/good1.png"
                            style="
                              cursor: pointer;
                              height: 15px;
                              display: inline-block;
                            "
                          />
                          <span> {{ item.likeNum }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <loading :showLoading="loading" />
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer">
      &nbsp;
      <!--<p class="line3" @click="contactUs" v-show="userId != ''">{{$t('contactUs.contactUs')}}</p>-->
    </div>
  </div>
</template>
<script>
//课程页轮播图
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import loading from "@/components/loading/loading";
//国际化引入
import Vue from "vue";
import { mapMutations } from "vuex";
import { lang } from "../../assets/languages/getLanguageType.js";
Vue.prototype.$lang = lang;

export default {
  name: "SchoolBusiness",
  components: {
    Swiper,
    SwiperSlide,
    loading
  },

  directives: {
    swiper: directive,
  },
  // props: ["userId"],
  data() {
    return {
      tagList: [],
      lang: "",
      allCourseNum: 0, //換一換
      limit: 30, //換一換
      // levelOnes: null,   //換一換
      pageNum: 0, //換一換
      lastPageFlag: 0, //換一換
      arrowdownCss: true, //設置課程分類用，手機版，下拉的顯示等
      isMobileFlg: false, //設置課程分類用，手機版，下拉的顯示等
      arrowdownIcon: true, //設置課程分類用，手機版，下拉的顯示等
      heightOut: 0, //設置課程分類用，手機版，下拉的顯示等
      heightIn: 0, //設置課程分類用，手機版，下拉的顯示等
      loading: false,
      optionsValue: 3,
      options: [
        {
          value: 1,
          label: "",
        },
        {
          value: 2,
          label: "必修",
        },
        {
          value: 3,
          label: "选修",
        },
      ],
      tagOne: null,
      tagTwo: null,
      userId: "",
      collegeSynopsis: "",
      courseList: {}, //必修课列表
      courseList_b: {}, //选修课列表
      menuList: {}, //一级菜单数据接收数组
      secondMenuList: {}, //二级菜单数据接收数组
      currentIndex: -1, //一级菜单当前显示样式
      newCurrentIndex: -1, //二级菜单当前显示样式
      changeState: false, //二级菜单是否显示
      swiperOption: {
        //轮播图样式控制器
        pagination: {
          //轮播图分页控制器
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          //轮播图导航控制器
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        slidesPerView: 3, //轮播图每页显示个数
        slidesPerGroup: 3, //3个一组
      },
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false, // 手动切换之后继续自动轮播
        },
        loop: true,
      },
      checkLoginUser: false,
    };
  },
  created() {
    //监听getMenuHeight
    window.addEventListener("resize", this.getMenuHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getMenuHeight);
  },
  mounted() {
    this.$autoLogin().then(
      () => {
        this.checkLoginUser = true;
      },
      () => {
        this.checkLoginUser = false;
      }
    );
    this.userId = window.sessionStorage.getItem("id");
    //获取设备屏幕的高度
    const h = document.body.clientHeight;

    if (this.$lang() == "1") {
      this.lang = "zh";
    } else if (this.$lang() == "2") {
      this.lang = "en";
    } else if (this.$lang() == "3") {
      this.lang = "ja";
    } else if (this.$lang() == "4") {
      this.lang = "vi";
    } else {
      this.lang = "en";
    }

    setTimeout(() => {
      this.getMenuHeight();
    }, 2000);

    //  取得一级标签信息
    this.loading = true;
    if (!this.userId) {
      const tagListAll = JSON.parse(
        window.sessionStorage.getItem("tagListAll")
      );

      if (tagListAll) {
        if (this.lang === "zh") {
          this.tagList = tagListAll.zh;
        }
        if (this.lang === "ja") {
          this.tagList = tagListAll.ja;
        }
        if (this.lang === "vi") {
          this.tagList = tagListAll.zh;
        }
        if (this.lang === "en") {
          this.tagList = tagListAll.ja;
        }
      } else {
        this.tagList = [];
      }
    }

    this.$api
      .post("/pullDownMenu/menuDataList", {
        language: this.$lang(),
        level: 1,
        tagOne: this.tagOne,
        tagTwo: this.tagTwo,
        // "allFlag":1,
        type: 2,
        flag: 0,
        tagList: this.tagList,
      })
      .then((response) => {
        this.menuList = response.data;
        this.loading = false;
      });

    // 从首页的更多，进入moreCourses，
    // 课程定位到具体的menu并打开二级分类
    // 如果定位在第二行，下拉自动打开；手机版，自动滑动到相应位置
    const tagOne = this.$route.query.tagOne;
    if (tagOne) {
      this.firstMenuChange(null, tagOne);
    } else {
      this.changeCourseList(-1, null); //数据部分（换一换），初始值为全部,30条
    }

    //我的课程轮播图初始化
    // this.mySwiper.slideTo(3, 1000, false);
    //推荐课程轮播图初始化
    // this.mySecondSwiper.slideTo(3, 1000, false);

    this.getMenuHeight();

    if (this._isMobile()) {
      this.isMobileFlg = true; //手机端
      this.arrowdownIcon = false;
    } else {
      this.isMobileFlg = false; //pc端
    }
  },

  methods: {
    checkIsUrl (val) {
      let regex = new RegExp(/^\[LiveStream\]\r\n(http:\/\/|https:\/\/).*$/);
      val.forEach(el => {
        if (regex.test(el.synopsis)) {
          el.isUrl =  true;
          let url = el.synopsis.split("\r\n");
          el.courseCover = "<iframe width='100% !important' height='100% !important' src='" + url[1] + "' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>"
        } else {
          el.isUrl = false;
        }
      })
      this.courseList_b = val;
    },
    //移动端：滑动功能，增加css的方式。
    //PC端：显示下拉箭头
    getMenuHeight() {
      const that = this;
      if (that.$refs.heightOut != undefined) {
        that.heightOut = that.$refs.heightOut.offsetHeight;
        that.heightIn = that.$refs.heightIn.offsetHeight;
        // console.log(this.heightOut)
        // console.log(this.heightIn)
        if (that.heightOut < that.heightIn) {
          that.arrowdownIcon = true;
        } else {
          that.arrowdownIcon = false;
        }
      }
    },
    //作用：点击换一换
    changeCourseList(tagOne, tagTwo) {
      this.pageNum = this.pageNum + 1;
      //初始值、切换课程
      if (tagOne != this.tagOne || tagTwo != this.tagTwo) {
        this.pageNum = 1;
        this.lastPageFlag = 0;
      }
      //判断是否最后一页
      let allpage = Math.ceil(this.allCourseNum / this.limit);
      if (this.pageNum == allpage && allpage != 0) {
        this.lastPageFlag = 1;
      } else {
        this.lastPageFlag = 0;
        if (this.pageNum > allpage) {
          this.pageNum = 1;
        }
      }
      //取得30条课程
      this.loading = true;
      this.companyId = window.sessionStorage.getItem("companyId");
      this.$api
        .post("/collegecourse/getMyCourseList", {
          levelOne: this.tagOne,
          levelTwo: this.tagTwo,
          pageNum: this.pageNum,
          limit: this.limit,
          lastPageFlag: this.lastPageFlag,
          languageType: this.$lang(),
          allFlag: 1,
          type: 1,
          flag: 0,
          checked: true,
        })
        .then((response) => {
          this.allCourseNum = response.data.length;
          this.checkIsUrl (response.data);
          this.loading = false;
        });
    },

    //作用：为primarymenu增加primarymenu-add
    cssedit() {
      this.arrowdownCss = !this.arrowdownCss;
    },
    contactUs() {
      this.$router.push("/home/contactUs");
    },
    //作用：判断终端设备
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },

    goRouter: function (url) {
      this.$router.push("/home/personSet");
    },
    goRouterSetCourse(url) {
      this.$router.push({
        path: url,
        query: {
          fromPagetype: JSON.stringify(1), //1:课程 ； 2:我的课程
          isPcflag: JSON.stringify(0), //0:Web端 ； 1:移动端
          isMoreCourse: true
        },
      });
    },
    ...mapMutations("header", ["setHistory"]),
    goto_Aicourse: function (courseId) {
      // if (this.userId == "" || this.userId == null) {
      //   this.$alert(window.vm.$i18n.t("js.PleaseLogin"), "", {
      //     confirmButtonText: window.vm.$i18n.t("js.confirm"),
      //   });
      //   return;
      // } else {
      //   window.sessionStorage.setItem("courseGOBackNum", 2);
      //   this.$router.push({
      //     name: "Aicourse",
      //     query: {
      //       buyCourseId: JSON.stringify(courseId),
      //       buyCollegeId: JSON.stringify(1),
      //     },
      //   });
      // }
      window.sessionStorage.setItem("courseGOBackNum", 2);
      this.setHistory("/home/moreCourses");
      //-----------------■コースセット対応--------------------------------------
      this.$api
      .post("/coursesPurchase/isScheduleCourse", {
          courseId: courseId
      })
      .then(response => {
          let isScheduleCourseFlag = response.data;
          if (isScheduleCourseFlag == 1) {
              this.$message.warning(window.vm.$i18n.t("new.title192"));
              return ;
          }else {
              // Đi đến chi tiết khóa học
              this.$router.push({
                  name: "Aicourse",
                  query: {
                      buyCourseId: JSON.stringify(courseId),
                      buyCollegeId: JSON.stringify(1),
                  },
              });
          }
      });
    },
    explore: function () {
      // 用 #explore 添加锚点
      let jump = document.querySelectorAll("#explore");
      let total = jump[0].offsetTop;
      let distance = document.getElementById("app").scrollTop;
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 50;
      if (total > distance) {
        smoothDown();
      } else {
        let newTotal = distance - total;
        step = newTotal / 50;
        smoothUp();
      }

      function smoothDown() {
        if (distance < total) {
          distance += step;
          document.getElementById("app").scrollTop = distance;
          setTimeout(smoothDown, 10);
        } else {
          document.getElementById("app").scrollTop = total;
        }
      }

      function smoothUp() {
        if (distance > total) {
          distance -= step;
          document.getElementById("app").scrollTop = distance;
          setTimeout(smoothUp, 10);
        } else {
          document.getElementById("app").scrollTop = total;
        }
      }
    },
    /*      isShow:function(){
			  isShow=false;
      },*/
    show_item: function () {
      isShow = true;
    },
    firstMenuChange: function (index, id) {
      this.pageNum = 1;
      this.lastPageFlag = 0;
      if (this.tagOne == id) {
        return;
      }
      this.secondMenuList = null;
      this.currentIndex = index;
      this.newCurrentIndex = -1;
      this.changeState = true;
      if (-1 == index) {
        this.tagOne = null;
        this.changeState = false;
        this.secondMenuList = null;
      } else {
        this.tagOne = id;
        //  取得二级标签信息
        this.loading = true;
        this.$api
          .post("/pullDownMenu/menuDataList", {
            language: this.$lang(),
            tagOne: this.tagOne,
            level: 2,
            tagList: [],
          })
          .then((response) => {
            this.secondMenuList = response.data;
          });
      }
      this.companyId = window.sessionStorage.getItem("companyId");
      //取得30条课程
      this.$api
        .post("/collegecourse/getMyCourseList", {
          levelOne: this.tagOne,
          levelTwo: this.tagTwo,
          pageNum: this.pageNum,
          limit: this.limit,
          lastPageFlag: this.lastPageFlag,
          languageType: this.$lang(),
          allFlag: 1,
          type: 1,
          flag: 0,
          checked: true,
        })
        .then((response) => {
          this.allCourseNum = response.data.length;
          this.checkIsUrl(response.data);
          this.loading = false;
        });
    },

    secondMenuChange: function (index, id) {
      this.pageNum = 1;
      this.lastPageFlag = 0;
      if (this.tagTwo == id) {
        return;
      }
      //点击添加样式
      this.newCurrentIndex = index;
      if (-1 == index) {
        this.tagTwo = null;
      } else {
        this.tagTwo = id;
      }
      this.loading = true;
      this.companyId = window.sessionStorage.getItem("companyId");
      //  取得30条课程
      this.$api
        .post("/collegecourse/getMyCourseList", {
          levelOne: this.tagOne,
          levelTwo: this.tagTwo,
          pageNum: this.pageNum,
          limit: this.limit,
          lastPageFlag: this.lastPageFlag,
          languageType: this.$lang(),
          allFlag: 1,
          type: 1,
          flag: 0,
          checked: true,
        })
        .then((response) => {
          this.allCourseNum = response.data.length;
          this.checkIsUrl(response.data);
          this.loading = false;
        });
    },
    handleListHidden: function () {
      this.changeState = false;
      this.currentIndex = -1;
    },
    mouseOverUp($event) {
      $event.currentTarget.className = "el-icon-arrow-up oaa";
    },
    mouseLeaveUp($event) {
      $event.currentTarget.className = "el-icon-arrow-up up_laa";
    },
    mouseOverDown($event) {
      $event.currentTarget.className = "el-icon-arrow-down oaa";
    },
    mouseLeaveDown($event) {
      $event.currentTarget.className = "el-icon-arrow-down down_laa";
    },
  },
};
</script>
<style scoped>
.main {
  padding-top: 60px;
}

a {
  text-decoration: none;
  color: white;
  -webkit-tap-highlight-color: white;
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}
.l {
  float: left;
}
.r {
  float: right;
}
.clear::after {
  content: ".";
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .container {
    width: 1000px;
  }
}
@media screen and (min-width: 800px) and (max-width: 1000px) {
  .container {
    width: 800px;
  }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .container {
    width: 600px;
  }
}
@media screen and (max-width: 600px) {
  .container {
    width: 400px;
  }
}
.swiper-container {
  margin-bottom: 20px;
  /* overflow: hidden;
    height: 450px; */
}
.swiper-container img {
  width: 100%;
}

.main {
  padding-top: 40px;
  /* background: #121212; */
  /*color: white;*/
}

.primarymenu {
  /*padding-bottom: 15px;*/
  position: relative;
}
.primarymenu-add {
  height: 39px;
  overflow: hidden;
}

.primarymenu ul {
  margin-right: 10px;
  margin-left: 10px;
}
.primarymenu .showAllCourse {
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
}
.primarymenu .showAllCourse img {
  width: 19px;
}
.primarymenu ul li {
  float: left;
  padding: 5px 15px;
  margin: 0 20px 0 0;
  background: #e0e0e0;
  color: #333;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 10px;
  font-size: 14px;
}
.primarymenu ul li:hover {
  background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  color: #fff;
}
.primarymenu ul li.active {
  background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  color: #fff;
  border: none;
}
.secondmenu ul {
  margin: 0 10px;
  padding: 20px 0 10px;
  background: #eee;
  border-radius: 5px;
}
.secondmenu ul li {
  float: left;
  padding: 5px 25px;
  background: #fff;
  margin: 0 10px 10px;
  border-radius: 20px;
  border: 1px solid #ccc;
  cursor: pointer;
  color: #333;
}
.secondmenu ul li:hover {
  background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  color: white;
  border: 1px solid #fff;
}
.secondmenu ul li.active {
  background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  border: none;
  color: white;
}

.change {
  cursor: pointer;
  margin-bottom: 5px;
  margin-top: 15px;
}
.change:hover {
  color: #02adff;
}
.change div {
  padding: 0 5px;
  font-size: 14px;
}
.change i {
  font-style: normal;
  font-weight: bold;
  margin-right: 3px;
}

.lists {
  min-height: 200px;
}
.lists ul {
  transform: translateX(5px);
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-around; */
}
.lists ul li {
  width: 190px;
  height: 170px;
  box-sizing: border-box;
  margin-right: 10px;
  margin-bottom: 30px;
  overflow: hidden;
  background: #333;
  border-radius: 5px;
  overflow: hidden;
}
.lists ul li .img {
  height: 100px;
  width: 100%;
  overflow: hidden;
}
.lists ul li .img img {
  width: 100%;
  height: 100%;
  transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -webkit-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
}
.lists .lessontitle {
  color: white;
  margin: 8px 0 3px;
  padding: 0px 10px;
  font-size: 15px;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.lists .lessontitle:hover {
  color: #02adff;
  cursor: pointer;
}
.lists .introduce {
  padding: 0 10px;
  color: #999;
  font-size: 12px;
  /* 1行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.lists .islike {
  float: right;
  margin: 2px 10px 3px 0px;
  color: #f8f8f8;
  font-size: 10px;
  cursor: pointer;
  overflow: hidden;
}

.lists.islike span {
  float: right;
}

.footer {
  padding: 50px 0 30px 0;
  color: white;
  text-align: center;
  background: url(../../../static/images/bg/myCourseBackgroundFoot.jpg)
    no-repeat center bottom;
  background-size: cover;
}
.footer .line1 {
  font-size: 46px;
}
.footer .line2 {
  font-size: 14px;
  margin-bottom: 30px;
}
.footer .line3 {
  display: inline-block;
  padding: 5px 50px;
  border: 1px solid white;
  border-radius: 20px;
}
.footer .line3:hover {
  background: white;
  color: black;
  cursor: pointer;
}
.swiper_bottom_shade {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
  height: 200px;
  width: 100%;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(224, 224, 219, 0)),
    to(#fff)
  );
  background: -webkit-linear-gradient(top, rgba(224, 224, 219, 0), #fff 100%);
  background: linear-gradient(180deg, rgba(224, 224, 219, 0), #fff 100%);
}
.primarymenu ul li.setCourse {
  background-image: -webkit-linear-gradient(315deg, #ff3f04 0%, #ff2e57 100%);
  background-image: linear-gradient(135deg, #ff3f04 0%, #ff2e57 100%);
  margin-right: 10px;
  /*margin-left:0px;*/
  padding: 5px;
}
.setCourse img {
  width: 19px;
}

.boxout {
}
.boxout .boxin {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
.boxout .boxin li.SchoolBusiness_menu_li {
  box-sizing: border-box;
}
::-webkit-scrollbar {
  display: none;
}
.vaa :hover {
  transform: scale(1.05, 1.05);
  cursor: pointer;
}
.down_laa {
  -webkit-text-stroke-width: 2px;
  color: #999;
}
.up_laa {
  -webkit-text-stroke-width: 2px;
  color: #00d3ff;
}
.oaa {
  -webkit-text-stroke-width: 2px;
  color: #ffb821;
}
.clear::after {
  content: ".";
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
}
.clear {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.primarylists {
  padding-top: 10px;
}

.primarylists > ul > li {
  padding-bottom: 50px;
  overflow: hidden;
}
.primarylists ul li .titles {
  height: 35px;
  width: 1000px; /* 需要配合JS动态设置宽度 */
  padding-bottom: 5px;
  color: black;
  margin-bottom: 10px;
  display: flex;
  inline-size: max-content;
}
.primarylists ul li .titles img {
  width: 32px;
  height: 32px;
  margin-top: 1px;
}
.primarylists ul li .titles .title {
  font-size: 24px;
  padding: 0 20px 0 10px;
  line-height: 35px;
  cursor: pointer;
  font-weight: bold;
}
.primarylists ul li .titles .more {
  font-size: 16px;
  line-height: 35px;
  cursor: pointer;
  padding-right: 20px;
}
.primarylists ul li .titles .more a {
  color: black;
}
.primarylists ul li .titles .title:hover {
  color: #02adff;
}
.primarylists ul li .titles .more :hover {
  color: #02adff;
}
.primarylists .secondlist {
  height: 100%;
  font-size: 16px;
}
.primarylists .secondlist ul li {
  float: left;
  padding: 3px 10px;
  cursor: pointer;
  margin-right: 16px;
  background: #666;
  border-radius: 15px;
  color: white;
}
.primarylists .secondlist ul li.choose {
  background: lightskyblue;
}

.primarylists .lessons ul {
  /* height: 350px; */
  height: auto;
  overflow: hidden;
  transform: translateX(5px);
}

.primarylists .lessons ul li {
  /* width: 190px;
  height: 170px; */
  width: 350px;
  height: auto;
  float: left;
  box-sizing: border-box;
  background: #333;
  background-clip: padding-box;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
}
/* .primarylists .lessons ul li:nth-of-type(1) {
  width: 390px;
  height: 350px;
}
.primarylists .lessons ul li:nth-of-type(1) .img {
  height: 200px;
} */
.primarylists .lessons ul li .img {
  height: 100px;
  width: 100%;
  overflow: hidden;
}
.primarylists .lessons ul li .img img {
  width: 100%;
  transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -webkit-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
}
.primarylists .lessons .lessontitle {
  padding: 0px 10px;
  margin: 8px 0 3px;
  color: #f8f8f8;
  font-size: 15px;
  cursor: pointer;
  /* 1行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.primarylists .lessons .lessontitle:hover {
  color: lightskyblue;
}
.primarylists .lessons .introduce {
  padding: 0 10px;
  color: #999;
  font-size: 12px;

  /* 1行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.primarylists .lessons .islike {
  float: right;
  margin: 2px 10px 3px 0px;
  color: #f8f8f8;
  font-size: 10px;
  cursor: pointer;
  overflow: hidden;
}

.primarylists .lessons .islike span {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/views/index/moreCourses.vue